/**
 * «به این دستگاه اعتماد دارم» (WHOSUP-349، مایگریشن 0188).
 *
 * نشستِ همین دستگاه را روی سرور مورد اعتماد علامت می‌زند؛ از آن به بعد «خروج»
 * روی هر دستگاهِ دیگری این یکی را نمی‌بندد (نگاه کن به `signOutEverywhere` در
 * lib/authSignOut). خودِ ماندنِ نشست روی دستگاه کارِ این فایل نیست — supabase
 * آن را از قبل نگه می‌دارد؛ چیزی که این‌جا عوض می‌شود فقط «چه کسی می‌تواند
 * ببندش» است.
 *
 * هرگز throw نمی‌کند: ورود موفق بوده و نباید به‌خاطرِ این گام شکست‌خورده دیده
 * شود. ولی شکستش **بی‌صدا هم نیست** (WHOSUP-374): `error` متنی است که صداکننده
 * باید به کاربر نشان بدهد — وگرنه تیک خورده به نظر می‌رسد و خروجِ بعدی روی
 * گوشی باز همین‌جا را می‌بندد. همین اتفاق روی develop افتاد، جایی که تابعش به
 * خاطرِ تداخلِ شماره‌ی مایگریشن اصلاً وجود نداشت.
 */
import { supabase } from './supabase.ts';
import { reportError } from './report.ts';

export interface TrustResult {
  ok: boolean;
  /** پیامِ خطا برای نشان دادن؛ فقط وقتی `ok` نیست. */
  error?: string;
}

export async function trustThisDevice(): Promise<TrustResult> {
  try {
    const { error } = await supabase.rpc('trust_this_device');
    if (error) throw error;
    return { ok: true };
  } catch (e) {
    reportError('auth.trustDevice', e);
    const msg = (e as { message?: unknown } | null)?.message;
    return { ok: false, error: typeof msg === 'string' && msg ? msg : String(e) };
  }
}
